import styled from "styled-components"

export const TitleWrapper = styled.h1`
  width: 100%;
  text-align: center;
  font-weight: 700;
`
